<template>
  <div>
    <!-- <headEnterprise></headEnterprise> -->
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <companySide
            class="mt-20"
            :isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <div class="mt-30">
            <paletteBar
              :paletteObj="paletteObj"
              @onPaletteBar="addSupply()"
              @onDelPalet="deleteSupply()"
              @onEditPalet="editSupply()"
              @onViewPalet="viewCount()"
            ></paletteBar>
            <div class="mt-20 fdw">
              <div class="picture" v-for="(item, index) in list" :key="index">
                <div class="pict_nox" @click="onView(item)">
                  <img :src="item.cover" alt="" />
                </div>
                <p>{{ item.title }}</p>
                <div class="place fcc mt-10" @click="onDetail(item)">
                  <!-- <el-checkbox-group v-model="checkList" @change="onChange">
                    <el-checkbox :label="item.id"></el-checkbox>
                  </el-checkbox-group> -->
                  <el-radio v-model="radio" :label="index" @change ="onChange"></el-radio>
                </div>
              </div>
            </div>

            <!--分页-->
            <Pagination
              v-show="total > 0"
              :total="total"
              :page.sync="listQuery.curPage"
              :limit.sync="listQuery.limit"
              @pageChange="pageChange"
            ></Pagination>
            <div style="margin-top: 20%">
              <notList :notCode="notCode"></notList>
            </div>
          </div>
          <!--浏览人数-->
          <div v-if="browse == true" class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
            <pictureLeftList
              :list="nubmerList"
              class="mt-20"
              v-if="browse == true"
            ></pictureLeftList>
            <Pagination
              v-show="totals > 0"
              :total="totals"
              :page.sync="dataQuery.curPage"
              :limit.sync="dataQuery.limit"
              @pageChange="pageNumber"
            ></Pagination>      
            <div style="margin-top:6%;">
              <notList :notCode="notCodes"></notList>
            </div>
             <div class="suup_upgrage" v-if="isTag" @click="onVip()">
              升级VIP，您可以查看用户浏览记录
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import { supplyListV2, delSupply} from "@/api/company";
import { myBrowseList } from "@/api/coment";
import headEnterprise from "../../common/headEnterprise";
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import paletteBar from "../../common/paletteBar";
import Pagination from "../../components/Pagination";
import pictureLeftList from "../../components/pictureLeftList";
import notList from "../../common/notList";
export default {
  components: {
    headEnterprise,
    sidebar,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    paletteBar,
    Pagination,
    pictureLeftList,
    notList,
  },
  data() {
    return {
      headTitle: "企业供应",
      contTitle: "企业基本信息",
      contTitle2: "浏览用户",
      obj: {
        title: "供应信息",
        isShow: false,
        isColor: false,
        roleType: 3,
        personalType: 9,
      },
      paletteObj: {
        paletteTitle: "企业供应",
        paletteCount: "",
        paletteName: "添加供应",
        paletteText: "删除供应",
        paletteView:'编辑供应',
        isShow: true,
        isDelete: true,
        isView: true,
        isEdit:true
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      labelPosition: "left",
      list: [],
      listQuery: {
        curPage: 1,
        limit: 8,
      },
      dataQuery: {
        curPage: 1,
        limit: 4,
        goodsType: 6,
        goodsId:''
      },
      total: 0, //总条数
      totals: 0,
      nubmerList: [], //浏览用户
      checkList: [],
      id: "",
      isButton: false,
      browse: false,
      notCode: false,
      notCodes:false,
      isTag: true,
      supply:{},
      radio:''
    };
  },
  created() {
    this.getList();
    let obj = this.$store.state.user.userInfo.data2;
    if (obj.id == 5) {
      this.isTag = false;
    };
  },
  methods: {
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //添加供应
    addSupply() {
      this.$router.push("/corporate_supplyAdd");
    },
    //编辑供应
    editSupply(){
      if(!this.radio.toString()){
         this.$message({
          message: "至少选择一条数据",
          type: "warning",
          duration: 1000,
        });
      }else{
        this.$router.push({
          path:'/corporate_supplyAdd',
          query:{id:this.id}
        });
      }
    },
    //列表
    getList() {
      supplyListV2(this.listQuery)
        .then((res) => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.total = res.data.totalCount;
            this.paletteObj.paletteCount = res.data.totalCount;
          }
          if (this.list.length == 0) {
            this.notCode = true;
          } else {
            this.notCode = false;
          }
        })
        .catch((err) => {});
    },
    //详情
    onView(data) {
      this.$router.push({
        path: "/supply_detail",
        query: { id: data.id },
      });
    },
    //删除
    deleteSupply() {
      if (!this.radio.toString()) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
          duration: 1000,
        });
      } else {
        let params = { id: this.id };
        this.$confirm("确定要删除吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delSupply(params)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: "删除成功！",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                      this.getList();
                    },
                  });
                }
              })
              .catch((err) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //产品分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getList();
    },
    //浏览用户分页
    pageNumber(item) {
      this.dataQuery["curPage"] = item.page;
      this.dataQuery["limit"] = item.limit;
      this.getNubmer();
    },
    //选中
    onChange(item) {
      this.radio = item;
    },
    //查看浏览人数
    viewCount() {
      if( !this.radio.toString()){
         this.$message({
          message: "至少选择一条数据",
          type: "warning",
          duration: 1000,
        });
      }else{
         this.dataQuery.goodsId = this.supply.id;
         this.browse = true;
         this.getNubmer();
      }
    },
    //浏览人数列表
    getNubmer() {
      myBrowseList(this.dataQuery)
        .then((res) => {
          if (res.code == 0) {
            this.nubmerList = res.page.list;
            this.totals = res.page.totalCount;
            res.page.list.length == 0 ? this.notCodes = true:this.notCodes = false;
          }
        }).catch((err) => {});
    },
    onDetail(data){
      this.supply = data;
      this.id = data.id;
    },
    //发布
    gorelease() {
      this.$router.push("/demand");
    },
    //升级VIP
    onVip() {
      this.$router.push("/corporate_member");
    },
  },
};
</script>
<style scoped>
/* .el-aside{
    height: 930px;
} */
.mt-20 {
  margin-top: 20px;
}
.picture {
  width: 23%;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-bottom: 20px;
  margin-right: 14px;
}
.pict_nox {
  overflow: hidden;
  height: 150px;
}
.pict_nox img {
  width: 100%;
  height: 150px;
  transition: all 0.6s;
}
.pict_nox img:hover {
  transform: scale(1.4);
}
.picture p {
  margin-top: 10px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-pagination {
  margin-top: 40px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3bae30 !important;
  color: #fff;
}

.place>>>.el-radio__label{ 
  display: none;
}



.el-form-item {
  text-align: left;
}
.custom {
  position: relative;
}
.custom p {
  position: absolute;
  top: 0;
  right: 12%;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.picture p {
  font-size: 14px;
}
.pictures {
  margin-top: 20px;
}
.wire {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}
.keep {
  width: 114px;
  background: #3cbc36;
  border-radius: 3px;
}
.new {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.new_add {
  margin-top: -20px;
  margin-right: 20px;
}
.new_reduce {
  margin-top: -20px;
  margin-right: 20px;
}

.text_center {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.suup_upgrage {
  margin-top: 30px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #e28b8b;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.picture >>> .el-checkbox__label {
  display: none;
}
.place >>> .el-checkbox__inner {
  border-radius: 50%;
  /* border: 1px solid #50b035; */
}
.place >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #50b035;
}

.place >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035;
  border-color: #50b035;
  border-radius: 50%;
}
.place >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50b035;
}
.place >>> .el-checkbox__inner:hover {
  background-color: #50b035;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_supply.vue